import { useStore } from "@nanostores/react";

import {
  $collapseButtonVisible,
  $sidebarCollapsed,
  sidebarActions,
} from "../Sidebar.store";

export const useSidebarCollapse = () => {
  const isCollapsed = useStore($sidebarCollapsed);
  const isCollapseButtonVisible = !useStore($collapseButtonVisible);

  return {
    isCollapsed,
    isCollapseButtonVisible,
    toggleCollapsed: sidebarActions.toggle,
    setCollapsed: sidebarActions.set,
    collapse: sidebarActions.collapse,
    expand: sidebarActions.expand,
    hideCollapseButton: sidebarActions.hideCollapseButton,
    showCollapseButton: sidebarActions.showCollapseButton,
    toggleCollapseButtonVisibility:
      sidebarActions.toggleCollapseButtonVisibility,
  };
};
